import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TAvailableReportRow } from './types';

export const DOWNLOAD_ACTION = 'Download';

export const REPORT_TYPE_FILTER_SELECTOR = 'reportTypeId';

/** Reports are mostly spreadsheets, used when the response does not name the file. */
export const DEFAULT_REPORT_FILE_EXTENSION = 'xlsx';

/** No column is sortable, the order is predefined (see `AVAILABLE_REPORTS_ORDER_BY`). */
export const tableStructure: TTableStructure<keyof TAvailableReportRow, TAvailableReportRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		/** Filtered by the type id, the options are filled in from the report types. */
		name: 'Report Type',
		selector: REPORT_TYPE_FILTER_SELECTOR,
		show: true,
		separateFilter: true,
		colSpan: 2,
		type: ETableStructureType.STATUS_NO_BG,
		align: ETableStructureAlign.LEFT,
		filter: [],
	},
	{
		name: 'Period',
		selector: 'period',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_PERIOD,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [{ name: DOWNLOAD_ACTION, icon: EIconButtons.DOWNLOAD }],
	},
];
